import React from "react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import classes from "./FeatureActionButton.module.scss";

const FeatureActionButton = ({ t, onClick, icon, label }) => {
  return (
    <Button
      className={classes["feature-action-button"]}
      onClick={onClick}
      variant="primary"
    >
      {icon && <span className={classes["button-icon"]}>{icon}</span>}
      {label && <span className={classes["button-label"]}>{t(label)}</span>}
    </Button>
  );
};

FeatureActionButton.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node,
  label: PropTypes.string,
};
FeatureActionButton.defaultProps = {
  icon: null,
  label: "",
};

export default FeatureActionButton;
